import {
  getHighVIUserRedirect,
  loader,
  redirect,
  getSooperPanelProps,
} from '../common';
import { registerPixels, execute3rdPartyPixels } from '../common/pixels';

export default class Processor {
  constructor(props) {
    /*
     ** [dispatcher, browserStorage, ?reporter]
     */
    Object.assign(this, props);
  }

  get props() {
    return window.sooper_panel.props;
  }

  get profile() {
    return this.props.profile;
  }

  getRequiredProps(panel) {
    Object.assign(this.props, getSooperPanelProps());
    return panel.required.reduce((acc, key) => {
      if (!Object.keys(this.props).includes(key)) {
        return acc;
      }

      if (key === 'user_id') {
        return { ...acc, [key]: this.browserStorage.userID };
      }

      const value =
        key !== 'profile' ? this.props[key] : this.props[key].values();
      return { ...acc, [key]: value };
    }, {});
  }

  async exec(panel) {
    let { override, r, ...params } = window.sooper_panel.query_params,
      props = this.getRequiredProps(panel);

    if (props?.certificate_url) {
      props.certificateUrl = props.certificate_url;
    }

    if (window.sooper_panel?.certificate_url) {
      props.certificateUrl = window.sooper_panel?.certificate_url;
    }

    props.anuranum = window.sooper_panel.props?.anuranum;
    props.anuraper = window.sooper_panel.props?.anuraper;

    return await this.dispatcher.send({
      ...this.getRequiredProps(panel),
      action: `${panel.action}?${new URLSearchParams(params).toString()}`,
    });
  }

  async report(panel) {
    if (this.reporter === false) {
      return;
    }

    if (
      panel.name === 'phone_number' &&
      (window.sooper_panel?.certificate_url || this.props.certificate_url)
    ) {
      return this.reporter.send({
        ...panel.data,
        certificateUrl:
          window.sooper_panel?.certificate_url || this.props.certificate_url,
      });
    }

    this.reporter.send(panel.data);
  }

  async stopAnimations() {
    if (typeof glimmer === 'number') {
      clearInterval(glimmer);
    }
  }

  async response(action, payload) {
    if (payload?.profile) {
      this.profile.update(payload.profile);
    }

    switch (action) {
      case 'email':
        this.stopAnimations();
        this.browserStorage.remove('userID');
        this.browserStorage.add({
          name: 'userID',
          value: payload?.user_id,
          days: 30,
        });
        this.props.user_id = payload?.user_id;
        registerPixels(payload?.pixels);
        execute3rdPartyPixels({
          id: this.props?.r,
          criteo_id: this.props.criteo_id,
          criteo_bucket_limit: this.props['criteo_bucket-limit'],
          funnel_id: this.props.funnel_id,
          user_id: this.props.user_id,
          EmailAddress: this.profile.email_address,
          VisitIndex: this.profile.VisitIndex,
        });

        // const highVisitIndexUri =
        //   getHighVIUserRedirect(
        //     this.profile?.email_address,
        //     this.profile?.VisitIndex,
        //   ) ?? false;

        // if (highVisitIndexUri) {
        //   const controller = window.sooper_panel.controller;
        //   controller.getPanelByFieldName('first_name').field.disabled = true;
        //   controller.continueBtn.disabled = true;

        //   setTimeout(() => {
        //     document.getElementById('labels').innerText =
        //       'Hang tight we have a special offer for you.';

        //     loader({
        //       status: 'hidden',
        //       panel: controller.getPanelByFieldName('first_name').elem,
        //       continueBtn: controller.continueBtn,
        //     });

        //     setTimeout(() => {
        //       window.location = `${highVisitIndexUri}&${new URLSearchParams(
        //         window.sooper_panel.query_params,
        //       ).toString()}`;
        //       // window.location = `https://e.fim7.com/tRB3N?visitid=${this.props.visit_id}&email_address=${this.profile.email_address}&first_name=${this.profile?.first_name}&zip_code=${this.profile?.zip_code}&visit_index=${this.profile.VisitIndex}&funnel_id=${this.props.funnel_id}&source=${this.props.source}`;
        //     }, 200);
        //   }, 500);
        // }
        break;

      case 'zip':
        for (let key of ['city', 'state']) {
          if (payload?.profile?.[key]) {
            let panel = window.sooper_panel.controller.getPanelByFieldName(key);
            panel?.elem?.setAttribute('optional', true);
          }
        }
        break;

      case 'submit':
        console.log('submitted');
        break;
    }
  }
}
